import { Injectable } from "@angular/core";

/**
 * Holds the breadcrumb trail for whichever drill-down page is currently
 * routed (e.g. analytics.component.ts sets ["Dashboard", "Total Scans"]).
 * Analytics, Generated QR Report and Product Intelligence render it in their
 * own page topbar (.az-breadcrumb / .gqr-breadcrumb / .pi-breadcrumb); the
 * navbar (header.component.html) still renders it in place of the "Hi <name>"
 * greeting for any other routed page, such as the Inventory report.
 *
 * A plain root-provided singleton, same reasoning as ScanFilterStateService:
 * only one routed page is ever mounted at a time, so there's no live
 * cross-component update to react to - each page just sets this on init and
 * clears it on destroy so a later page with no breadcrumb of its own doesn't
 * inherit a stale one.
 */
@Injectable({
  providedIn: "root",
})
export class BreadcrumbService {
  items: string[] = [];
}
